import { Box, Typography, useTheme, Tooltip } from "@mui/material";
import PhoneCallIcon from "@/assets/icons/phone-call";

interface InCallIndicatorProps {
  agentName?: string;
  showLabel?: boolean;
  variant?: "positive" | "secondary";
  testId?: string;
}

const InCallIndicator = ({
  agentName,
  showLabel = true,
  variant = "positive",
  testId,
}: InCallIndicatorProps) => {
  const theme = useTheme();

  if (!agentName) return null;

  const isSecondary = variant === "secondary";
  const color = isSecondary
    ? theme.nawy.colors.semantic.text.secondary
    : theme.nawy.colors.semantic.text.extension.positive;
  const iconFill = isSecondary
    ? theme.nawy.colors.semantic.text.secondary
    : "#3E8D7B";

  const tooltipTitle = `${agentName} is on a call`;

  return (
    <Tooltip title={tooltipTitle} arrow>
      <Box
        data-testid={testId}
        sx={{
          display: "flex",
          alignItems: "center",
          flexWrap: "nowrap",
          whiteSpace: "nowrap",
          gap: showLabel ? theme.nawy.spacing.xs : 0,
        }}
      >
        <PhoneCallIcon fill={iconFill} />
        {showLabel && (
          <Typography
            sx={{
              color,
              ...theme.nawy.typography.english.variants.body.xs.regular,
              lineHeight: 1,
              letterSpacing: "0.02em",
            }}
          >
            In call
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default InCallIndicator;
